import {
  type EvalBatchCreateRequest,
  EvalBatchCreateResponseSchema,
  EvalBatchDetailResponseSchema,
  EvalBatchListResponseSchema,
} from "contracts/api/evals/batches";
import {
  EvalComparisonDetailResponseSchema,
  type EvalHumanJudgmentRequest,
  EvalHumanJudgmentResponseSchema,
} from "contracts/api/evals/comparisons";
import {
  type EvalSuiteCreateRequest,
  EvalSuiteCreateResponseSchema,
  EvalSuiteListResponseSchema,
} from "contracts/api/evals/suites";
import { request } from "./api-client";

export const evalsApi = {
  listSuites: () =>
    request("GET", "/api/evals/suites", EvalSuiteListResponseSchema),
  createSuite: (input: EvalSuiteCreateRequest) =>
    request("POST", "/api/evals/suites", EvalSuiteCreateResponseSchema, input),
  listBatches: (suiteId: string | null) =>
    request(
      "GET",
      suiteId ? `/api/evals/batches?suiteId=${suiteId}` : "/api/evals/batches",
      EvalBatchListResponseSchema,
    ),
  batchDetail: (batchId: string) =>
    request(
      "GET",
      `/api/evals/batches/${batchId}`,
      EvalBatchDetailResponseSchema,
    ),
  createBatch: (input: EvalBatchCreateRequest) =>
    request("POST", "/api/evals/batches", EvalBatchCreateResponseSchema, input),
  // 409 while the pair is still half-analysed. The caller decides what that
  // means; see `comparisonNotReady` in features/evals/comparisonState.
  comparisonDetail: (comparisonId: string) =>
    request(
      "GET",
      `/api/evals/comparisons/${comparisonId}`,
      EvalComparisonDetailResponseSchema,
    ),
  recordHumanJudgment: (
    comparisonId: string,
    input: EvalHumanJudgmentRequest,
  ) =>
    request(
      "POST",
      `/api/evals/comparisons/${comparisonId}/human-judgment`,
      EvalHumanJudgmentResponseSchema,
      input,
    ),
};
